module.exports = __webpack_public_path__ + "static/img/home_banner_0.7a06f338.jpg";